<template>

    <v-card>
        <v-snackbar :timeout="servicesData.timeout" color="success" top v-model="snackbar">
            <v-btn @click="$emit('formResponse')" dark text>Close</v-btn>
        </v-snackbar>
        <v-toolbar class="darken-4" color="indigo" dark>
            <v-toolbar-title>
                {{$t('rowshowhide')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn @click="dialogueClose" dark text>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-container>
                <form>
                    <v-expansion-panels multiple v-model="panel">
                        <v-row>
                            <v-col :key="sectionData.id"
                                   cols="6" v-for="(sectionData) in listDatas">
                                <v-expansion-panel>
                                        <div :key="sectionData.reportName">
                                        <div class="ml-10">
                                            <v-checkbox :label="sectionData.reportName"
                                                        @change="updatedCheckSection(sectionData.assignReportId,sectionData.tickUntick)"
                                                        v-model="sectionData.tickUntick"></v-checkbox>
                                        </div>
                                    </div>

                                </v-expansion-panel>
                            </v-col>
                        </v-row>
                    </v-expansion-panels>

                </form>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-row justify="center">
                <v-btn @click="tableSectionSubmit" color="primary">{{$t('submit')}}</v-btn>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";
    import { mapGetters } from "vuex";

    export default {
        name: "SettingsModel",
        props: ['logResponseData'],
        data() {
            return {
                listDatas:[],
                reportID: this.$route.params.id,
                ReportIds : [],
                color: "",
                servicesData: {
                    data: {},
                    message: "",
                    color: "",
                    timeout: 4000
                }
            };
        },
        filters: {
            checkCount: function (value) {
                let count = value.filter(res=> res.rowShow == true)
                let rowCount = count.length >0 ? count.length : ''
                return rowCount
            }
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            relsFiltered: {
                get() {
                    return this.headers;
                },
                set(data) {
                    this.headers = data;
                }
            }
        },
        mounted() {
            this.formOption();
        },
        methods: {
            updatedCheckSection(id, status) {
                if (status) {
                    this.ReportList.push(id)
                } else {
                    this.ReportList.splice(this.ReportList.indexOf(id), 1);
                }
            },
            tableSectionSubmit() {
                let postData = {
                    ...this.logResponseData,

                    ReportList: [...new Set(this.listDatas)],
                }

                let data = {
                    departmentID: parseInt(postData.departmentID),
                    companyID: 0,
                    branchID: 0,
                    depoID: 0,
                    companyType: '',
                    reportList: [...new Set(this.listDatas)],

                };

                console.log('here',data)

                axios.post("AssignReport/InsertDepartmentAssignReport", data).then(response => {
                    console.log(response.data)
                    this.snackbar = true
                    this.servicesData.updated = true
                    this.$emit("formResponse", this.servicesData);
                    this.servicesData.message = "Sub section visibility updated successfully"
                })
            },
            dialogueClose() {

                this.$emit("formResponse", this.servicesData);

            },
            async formOption() {
                let postData = {
                    ...this.logResponseData,
                }
                let data = {
                    departmentID: parseInt(postData.departmentID),
                    companyType: this.usersData.role,
                };

                axios.post("AssignReport/GetCompanyDepartmentAssignReport", data).then(response => {
                    this.listDatas = response.data;
                })

            },
            submit() {
                console.log(this.relsFiltered, this.formData.activeHeader)
            },

            removeA(arr) {
                var what, a = arguments, L = a.length, ax;
                while (L > 1 && arr.length) {
                    what = a[--L];
                    while ((ax = arr.indexOf(what)) !== -1) {
                        arr.splice(ax, 1);
                    }
                }
                return arr;
            },

            selectAll(val, index) {
                if (this.topHeaderID[index] === true) {

                    this.getSectionList.filter(res => {
                        return res.sectionID == val
                    }).forEach(res => {
                        res.list.forEach(res => {
                            res.rowShow = true
                            this.subSectionID.push(res.subSectionID)
                        })
                    })
                    console.log(this.getSectionList)
                } else {
                    this.getSectionList.filter(res => {
                        return res.sectionID == val
                    }).forEach(res => {
                        res.list.filter(res => {
                            res.rowShow = false
                            this.removeA(this.subSectionID, res.subSectionID);
                            // this.subSectionID.splice(res.subSectionID, 1);
                        })
                    })


                    console.log(this.getSectionList)

                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .hr-divider {
        width: 100%;
        max-width: 100%;
        border-width: 1px;
    }
    .section-count{
        text-align: right;
    }
</style>
